import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { TaxGuideResponse } from '@/api/tax-guide';

type DownloadButtonProps = {
  isDownloading: boolean;
  content?: TaxGuideResponse;
  downloadCall: () => void;
  buttonText: string;
};

const DownloadButton = ({
  isDownloading,
  content,
  downloadCall,
  buttonText,
}: DownloadButtonProps) => {
  return (
    <Button
      variant="outlined"
      startIcon={
        isDownloading ? <CircularProgress size={20} /> : <FileDownloadIcon />
      }
      onClick={downloadCall}
      sx={{
        fontSize: 'inherit',
        ariaLabel: 'Download PDF button',
        ariaRoledescription: 'button',
      }}
      disabled={(content?.data?.content ? false : true) || isDownloading}
    >
      {isDownloading ? 'Downloading' : buttonText}
    </Button>
  );
};

export default DownloadButton;
